module.exports = __webpack_public_path__ + "static/media/Drone-Video-2.1b709483.mp4";